export const getTagUrl = (sectionUrl, slug) => `${sectionUrl}/tags/${slug}/`;
